export type AffiliationRole = 'apprentice' | 'tutor' | 'manager';
export type AffiliationStatus = 'active' | 'ended';

/**
 * Index par identité au-dessus des tableaux de formation (training.managers[],
 * training.apprentices[]{id, tutors[]}), qui restent la source de vérité — voir
 * rapport-link-up/PLAN_SPRINTS_ET_AUDIT_ROLES.md, section Sprint 2.
 *
 * Alumni = role:'apprentice', status:'ended'. Pas de 4e valeur de rôle.
 */
export class Affiliation {
  constructor(
    public identityId: string,
    public trainingId: string,
    public trainingCenterId: string,
    public role: AffiliationRole,
    public status: AffiliationStatus,
    public grantedBy: string,
    public networkId?: string | null,
    public id?: string,
    public createdAt?: string,
    public updatedAt?: string,
    public endedAt?: string | null,
  ) {}

  /**
   * Clé déterministe : le cumul de rôle dans une même formation est interdit,
   * donc il n'existe structurellement qu'une place par couple (identité,
   * formation). `get()` plutôt qu'une requête, côté code comme côté règles.
   */
  static buildId(identityId: string, trainingId: string): string {
    return `${identityId}_${trainingId}`;
  }

  static fromObject(data: any): Affiliation {
    return new Affiliation(
      data?.identityId,
      data?.trainingId,
      data?.trainingCenterId,
      data?.role,
      data?.status,
      data?.grantedBy,
      data?.networkId ?? null,
      data?.id,
      data?.createdAt,
      data?.updatedAt,
      data?.endedAt ?? null,
    );
  }

  static toObject(affiliation: Affiliation): any {
    const data: any = {
      identityId: affiliation.identityId,
      trainingId: affiliation.trainingId,
      trainingCenterId: affiliation.trainingCenterId,
      role: affiliation.role,
      status: affiliation.status,
      grantedBy: affiliation.grantedBy,
      networkId: affiliation.networkId ?? null,
    };

    if (affiliation.createdAt !== undefined) {
      data.createdAt = affiliation.createdAt;
    }
    if (affiliation.updatedAt !== undefined) {
      data.updatedAt = affiliation.updatedAt;
    }
    if (affiliation.endedAt !== undefined) {
      data.endedAt = affiliation.endedAt;
    }

    return data;
  }
}
